import { render, staticRenderFns } from "./withdraws.vue?vue&type=template&id=351964ee&scoped=true"
import script from "./withdraws.vue?vue&type=script&lang=js"
export * from "./withdraws.vue?vue&type=script&lang=js"
import style0 from "./withdraws.vue?vue&type=style&index=0&id=351964ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351964ee",
  null
  
)

export default component.exports